import { motion } from 'framer-motion';
import { LayoutGridIcon, GemIcon, AwardIcon, MessageCircleIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/q7RnjxXyHz353QdkW84P8k/IMG_5459.jpg';
const KIT_NEGRO_URL = 'https://e04whn-0h.myshopify.com/products/kit-negro-premium-para-extensiones-de-pestanas';
const KIT_ROSADO_URL = 'https://e04whn-0h.myshopify.com/products/kit-rosado-premium-para-extensiones-de-pestanas';
const WHATSAPP_URL = 'https://wa.me/16159848577?text=Hola%20Karina%20%F0%9F%91%8B%20Vi%20tus%20servicios%20de%20dise%C3%B1o%20de%20cejas%20en%20Alexa%20Beauty%20y%20me%20gustar%C3%ADa%20agendar%20una%20cita.%20%C2%BFQu%C3%A9%20disponibilidad%20tienes%3F';
const GOLD = '#C9A96E';
const benefits = [{
  icon: LayoutGridIcon,
  label: 'Organización inteligente'
}, {
  icon: GemIcon,
  label: 'Calidad Premium'
}, {
  icon: AwardIcon,
  label: 'Diseñado para profesionales'
}];
export function BrandClosing() {
  return <section id="cierre-marca" className="relative overflow-hidden px-5 sm:px-6 pt-16 pb-20 sm:pt-24 sm:pb-28 lg:pt-28 lg:pb-32" style={{
    background: 'linear-gradient(180deg, #ffffff 0%, #fdfbf7 45%, #f7f0e4 100%)'
  }} data-id="element-63" data-mp="31hm5142us1fz">
      {/* Oversized brand signature watermark */}
      <img src={LOGO_URL} alt="" aria-hidden="true" className="pointer-events-none select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] mix-blend-multiply opacity-[0.08] z-0" data-id="element-64" data-mp="2whgejr8bkkzh" />

      <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-65" data-mp="3p4ucnsnr7ml6">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-66" data-mp="3a8uutqaue82u">
          <h2 className="font-serif text-3xl md:text-5xl text-luxury-black leading-tight mb-8" data-id="element-67" data-mp="1ytfxgleq1e77">
            Tu talento merece herramientas a la altura de tu trabajo.
          </h2>

          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="mx-auto mb-8 h-[1px] w-20 origin-center" style={{
          backgroundColor: GOLD
        }} data-id="element-68" data-mp="ab4rajs2a4mu" />

          <p className="text-base md:text-lg text-gray-600 font-sans font-light leading-relaxed max-w-2xl mx-auto mb-10 sm:mb-14" data-id="element-69" data-mp="3rqblk3hjuquf">
            Cada detalle transmite confianza. Organiza tus herramientas, protege
            tus materiales y proyecta una imagen profesional desde el primer
            momento con Alexa Beauty.
          </p>
        </motion.div>

        {/* Benefits */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-7 sm:gap-14 mb-10 sm:mb-14" data-id="element-70" data-mp="38tad28ose8lq">
          {benefits.map(({
          icon: Icon,
          label
        }) => <div key={label} className="flex flex-col items-center gap-3" data-id="element-71" data-mp="1jjq6zn94ntbu">
              <Icon className="w-5 h-5" style={{
            color: GOLD
          }} data-id="element-72" data-mp="1jhn6g9acmhsv" />
              <span className="text-xs tracking-[0.15em] uppercase text-luxury-dark font-sans" data-id="element-73" data-mp="1obho776e8mpb">
                {label}
              </span>
            </div>)}
        </motion.div>

        {/* Buttons */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.35
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-74" data-mp="vnc14drvalmb">
          <motion.a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full sm:w-auto text-center bg-luxury-black hover:bg-luxury-dark text-white font-sans font-medium text-xs tracking-[0.2em] uppercase px-12 py-4 transition-colors duration-500" data-id="element-75" data-mp="1ajtaizghxq68">
            🖤 Comprar Kit Negro
          </motion.a>

          <motion.a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full sm:w-auto text-center bg-rosado hover:bg-rosado-light text-white font-sans font-medium text-xs tracking-[0.2em] uppercase px-12 py-4 transition-colors duration-500" data-id="element-76" data-mp="2ti93m3h6f9eo">
            🌸 Comprar Kit Rosado
          </motion.a>
        </motion.div>

        {/* Brow services — secondary intent, clearly separated from the kits */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="mt-14 sm:mt-20" data-id="element-77" data-mp="37b7eyza0lc3v">
          <div className="mx-auto h-[1px] w-16" style={{
          backgroundColor: GOLD
        }} data-id="element-78" data-mp="4n6ff34broso" />

          <p className="mt-8 sm:mt-10 text-[11px] sm:text-xs font-sans font-medium uppercase tracking-[0.25em] sm:tracking-[0.3em]" style={{
          color: GOLD
        }} data-id="element-79" data-mp="8o9uvoignitd">
            Brow Services by Karina
          </p>

          <h3 className="mt-4 sm:mt-5 font-serif text-luxury-black mx-auto max-w-[22ch]" style={{
          fontSize: 'clamp(1.5rem, 4vw, 2.25rem)',
          lineHeight: 1.15
        }} data-id="element-80" data-mp="3vw3rj8vfpn6z">
            ¿Tus cejas? También las dejamos en buenas manos.
          </h3>

          <p className="mt-5 font-sans font-light text-gray-600 mx-auto max-w-[48ch]" style={{
          fontSize: 'clamp(0.9375rem, 1.5vw, 1.0625rem)',
          lineHeight: 1.6
        }} data-id="element-81" data-mp="382lpg4cpdydt">
            Realza tu mirada con un diseño de cejas personalizado, pensado para
            complementar tus facciones y conseguir un resultado natural, limpio
            y elegante.
          </p>

          <div className="mt-8 flex justify-center" data-id="element-82" data-mp="2f9qf2dpp6l4g">
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex sm:inline-flex items-center justify-center gap-2.5 w-full sm:w-auto min-h-[52px] border border-luxury-black text-luxury-black active:bg-luxury-black active:text-white sm:hover:bg-luxury-black sm:hover:text-white font-sans font-medium text-xs tracking-[0.2em] uppercase px-10 py-4 transition-colors duration-300" data-id="element-83" data-mp="2f85nmwyojiat">
              <MessageCircleIcon className="w-[18px] h-[18px]" aria-hidden="true" data-id="element-84" data-mp="2szu0j2gr6asu" />
              Agendar diseño de cejas
            </a>
          </div>

          <p className="mt-4 text-sm text-gray-500 font-sans" data-id="element-85" data-mp="1hnt20vu377zw">
            Citas directamente con Karina por WhatsApp.
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="mt-14 sm:mt-20 text-xs tracking-[0.3em] uppercase font-sans" style={{
        color: GOLD
      }} data-id="element-86" data-mp="3ob0hubpl8hdq">
          Alexa Beauty · Brows And Lashes
        </motion.p>
      </div>
    </section>;
}